import http from '@/utils/http';

// const resolveResponse = (request) => {
//   return new Promise((resolve, reject) => {
//     request.then(result => {
//       resolve(result);
//     }).catch((error) => {
//       resolve(error);
//     });
//   });
// };

const ajax = {};

ajax.post = function (url, params) {
  return new Promise((resolve, reject) => {
    http.post(url, params).then(result => {
      resolve(result.data);
    }).catch((error) => {
      resolve(error);
    });
  });
};

ajax.get = function (url) {
  return new Promise((resolve, reject) => {
    http.get(url).then(result => {
      resolve(result.data);
    }).catch((error) => {
      resolve(error);
    });
  });
};

export default ajax;



// WEBPACK FOOTER //
// ./src/api/_ajax.js